import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router";
import { queryRolePlaceByRoleSeq, updateRolePlaceList } from "../../utility/service/personal-service";
import { checkDpSuccess } from "../../utility/service/tool-service";
import { handleSuccessMessage, MessageContext } from "../../store/messageStore";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { AcctContext } from "../../utility/useReduce/userNameReduce";

/** F2020105/F2020106 角色場所設定 **/
const RolePlaceMaintain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { itemObj } = useOutletContext();
  const [acctState] = useContext(AcctContext) || [];
  const [selected, setSelected] = useState([]);
  const [placeList, setPlaceList] = useState([]);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [, loading] = useContext(SystemLoading);
  const isEditable = useEditableFlag("F202"); // 同權限管

  const axios_queryRolePlaceByRoleSeq = useCallback(
    (roleSeq) => {
      checkLoading(loading);
      const companySeq = itemObj?.companySeq || acctState?.companySeq || "";
      queryRolePlaceByRoleSeq({ roleSeq, companySeq })
        .then((res) => {
          if (checkDpSuccess(res)) {
            const list = res?.data?.RespBody?.placeList || [];
            setPlaceList(list);
            const checked = list?.filter((p) => p.isCheck === "Y");
            setSelected(checked);
          }
        })
        .finally(() => checkLoading(loading, false));
    },
    [loading, itemObj?.companySeq, acctState?.companySeq],
  );

  useEffect(() => {
    if (JSON.stringify(itemObj) !== "{}") {
      axios_queryRolePlaceByRoleSeq(itemObj?.roleSeq);
    } else {
      navigate("/management/rolePermission");
    }
  }, [itemObj, axios_queryRolePlaceByRoleSeq, navigate]);

  const axios_updateRolePlaceList = (reqBody) => {
    checkLoading(loading);
    updateRolePlaceList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
          navigate("/management/rolePermission", { state: { roleSeq: itemObj?.roleSeq } });
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  const handleSelectionChange = (e) => {
    const selectedItems = e.value.filter((rowData) => !rowData.disabled);
    setSelected(selectedItems);
  };

  const handleUpdateData = () => {
    let reqBody = {
      roleSeq: itemObj?.roleSeq,
      placeSeqList: selected?.map((p) => p?.placeSeq),
    };
    axios_updateRolePlaceList(reqBody);
  };

  return (
    <>
      {/* 返回列表 */}
      <div className="align-items-start">
        <Button
          rounded
          text
          onClick={() => {
            navigate("/management/rolePermission");
          }}
        >
          <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
          {t("button.return_to_list")}
        </Button>
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <div className="grid">
            <div className="col-12">
              <label className="font-semibold mr-3">{t("role_symbol")}</label>
              <span>{itemObj?.symbol}</span>
            </div>
            <div className="col-12">
              <label className="font-semibold mr-3"> {t("role_name")}</label>
              <span>{itemObj?.name}</span>
            </div>
          </div>
          <hr />

          <DataTable
            dataKey="placeSeq"
            className={`white-data-table hover-highlight ${!isEditable ? "disabled-table" : ""}`}
            value={placeList}
            tableStyle={{ minWidth: "55rem" }}
            emptyMessage={t("no_rec")}
            selectionMode={isEditable ? "checkbox" : null}
            selection={selected}
            onSelectionChange={isEditable ? handleSelectionChange : undefined}
            scrollable
            resizableColumns
            isDataSelectable={(rowData) => !rowData.disabled}
            rowClassName={(rowData) => {
              return `${rowData.disabled ? "p-disabled" : ""}`;
            }}
          >
            <Column
              style={{ textAlign: "center", padding: "1px!important" }}
              selectionMode="multiple"
              headerStyle={{ width: "1rem" }}
            />
            <Column field="name" header={t("place_name")} className="font-bold" />
          </DataTable>
          <div className="grid mt-2">
            <div className="col-12 gap-2 flex-all-center">
              <Button
                disabled={!isEditable}
                onClick={() => {
                  handleUpdateData();
                }}
                label={t("button.update")}
                size="small"
              />
              <Button
                outlined
                size="small"
                label={t("button.cancel")}
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/management/rolePermission", { state: { roleSeq: itemObj?.roleSeq } });
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RolePlaceMaintain;
